<template>
  <div id="flash" :class="currentClass" >

    <span style="font-weight: normal" >
      <i v-if="alert == 'danger'" class="bi bi-exclamation-triangle-fill me-2"></i>
      <slot></slot>
    </span>


  </div>
</template>
<script>


export default {
  components: {
  },
  props: {
    alert: {
      default:'',
    },
  },
  computed: {
    currentClass() {
      let classes = 'alert ';
      if(this.alert === 'success'){
        classes += 'alert-success';
      } else if(this.alert === 'warning') {
        classes += 'alert-warning';
      } else if(this.alert === 'danger') {
        classes += 'alert-danger';
      }
      return classes;
    }
  }
}

</script>
